module.exports = __webpack_public_path__ + "static/media/app-and-play.41a70d5a.svg";